//转换函数--13个
export const TranslateFunc = [
  {
    "key": "ToStringX",
    "name": "轉字符串",
    "params": [
      {
        "key": "obj",
        "name": "轉換對象",
        "type": "object"
      }
    ],
    "description": `【功能】：將轉換值轉換為字符串\n【返回值類型】：字符串(String)\n【示例】：轉字符串(123)【返回值】："123"`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToDateTime",
    "name": "轉日期時間",
    "params": [
      {
        "key": "obj",
        "name": "轉換對象",
        "type": "object"
      }
    ],
    "description": `【功能】：將轉換值轉換成日期時間\n【返回值類型】：日期時間(OffsetDateTime)\n【示例】：轉日期時間("2019-01-30T10:00:00+08:00")【返回值】: 2019-01-30T10:00+08:00`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToBoolean",
    "name": "轉布爾值",
    "params": [
      {
        "key": "obj",
        "name": "轉換對象",
        "type": "object"
      }
    ],
    "description": `【功能】：將轉換值轉換成等效的布爾值\n【返回值類型】：布爾值(Boolean)\n【示例】：轉布爾值("True")【返回值】：true`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToDecimal",
    "name": "轉數值"
  },
  {
    "key": "ToBigDecimal",
    "name": "轉數值",
    "params": [
      {
        "key": "obj",
        "name": "轉換對象",
        "type": "object"
      }
    ],
    "description": `【功能】：將轉換值轉換成十進制數值\n【返回值類型】：十進制數值(BigDecimal)\n【示例】：轉數值("40.23")【返回值】：40.23`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToCustomBigDecimal",
    "name": "轉自定義精度數值",
    "params": [
      {
        "key": "obj",
        "name": "轉換對象",
        "type": "object"
      },
      {
        "key": "number",
        "name": "小數位數",
        "type": "int"
      }
    ],
    "description": `【功能】：將轉換值轉換成指定精度的十進制數值\n【返回值類型】：十進制數值(BigDecimal)\n【示例】：轉自定義精度數值("40.2,2")【返回值】：40.20`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToDouble",
    "name": "轉雙精度浮點數",
    "params": [
      {
        "key": "obj",
        "name": "轉換對象",
        "type": "object"
      }
    ],
    "description": `【功能】：將轉換值轉換成雙精度浮點數\n【返回值類型】：雙精度浮點數(Double)\n【示例】：轉雙精度浮點數("40.23")【返回值】：40.23`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToSingle",
    "name": "轉單精度浮點數"
  },
  {
    "key": "ToFloat",
    "name": "轉單精度浮點數",
    "params": [
      {
        "key": "obj",
        "name": "轉換對象",
        "type": "object"
      }
    ],
    "description": `【功能】：將轉換值轉換成單精度浮點數\n【返回值類型】：單精度浮點數(Float)\n【示例】：轉單精度浮點數("40.23")【返回值】：40.23`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToByte",
    "name": "轉8位無符號整數",
    "params": [
      {
        "key": "obj",
        "name": "轉換對象",
        "type": "object"
      }
    ],
    "description": `【功能】：將轉換值轉換成8位無符號整數\n【返回值類型】：8位無符號整數(Byte)\n【示例】：轉8位無符號整數("10")【返回值】：10`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToInt16",
    "name": "轉16位有符號整數",
    "params": [
      {
        "key": "obj",
        "name": "轉換對象",
        "type": "object"
      }
    ],
    "description": `【功能】：將轉換值轉換成16位有符號整數\n【返回值類型】：16位有符號整數(Int16)\n【示例】：轉16位有符號整數("10")【返回值】：10`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToInt32",
    "name": "轉32位有符號整數",
    "params": [
      {
        "key": "obj",
        "name": "轉換對象",
        "type": "object"
      }
    ],
    "description": `【功能】：將轉換值轉換成32位有符號整數\n【返回值類型】：32位有符號整數(Int32)\n【示例】：轉32位有符號整數("10")【返回值】：10`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToChineseMoney",
    "name": "轉中文大寫金額",
    "params": [
      {
        "key": "obj",
        "name": "轉換對象",
        "type": "object"
      }
    ],
    "description": `【功能】：將轉換值轉換成中文大寫金額\n【返回值類型】：字符串(String)\n【示例】：轉中文大寫金額(40.23)【返回值】："肆拾元零貳角叁分"`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  }
]